<template>
  <div class="empty-result">
    <img class="icon" src="@/assets/zs_imgs/empty-result.png" alt="暂无筛选结果" />
    <span class="txt">暂无筛选结果</span>
    <span class="more" @click="$emit('more')">查看更多</span>
  </div>
</template>
<script>
export default {
  name: "EmptyResult"
};
</script>
<style lang="less" scoped>
.empty-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20vh;
  .icon {
    width: 204px;
    height: 146px;
  }
  .txt {
    color: #888888;
    font-size: 13px;
  }
  .more {
    margin-top: 17px;
    font-size: 11px;
    color: #7d90c9;
    &::after {
      content: ">";
    }
  }
}
</style>
